// extracted by mini-css-extract-plugin
export default {"mainContainer":"Styles_mainContainer__JlLtp","slider1":"Styles_slider1__4S8yT","slider2":"Styles_slider2__+2ANa","submittedForm":"Styles_submittedForm__+Bqwg"};